import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardHeader } from "reactstrap";
import classNames from "classnames";
import NTable from "../../../components/NTable";
import { useNewTable } from "../../../components/NTable/hook";
import { useColumns } from "./columns";
import { useQueryFilters } from "../../Settings/helpers/useQueryFilters";
import { useRetroApi } from "./api";
import { useApproveDenyModal } from "./ApproveDenyModal/useApproveDenyModal";
import { useDetailsModal } from "./DetailsModal/useDetailsModal";

const status = ["pending", "approved", "applied", "rejected"];

function RetroAdjustment() {
    const { t } = useTranslation();
    const [selected, setSelected] = useState("pending");
    const { get, loading, data, totalItems, setData, setTotalItems } = useRetroApi();
    const {
        open: openApproveDenyModal,
        modal: approveDenyModal
    } = useApproveDenyModal({ setData, setTotalItems, selectedStatus: selected });
    const { open: openDetailsModal, modal: detailsModal } = useDetailsModal();
    const columns = useColumns({ openDetailsModal, openApproveDenyModal, selectedStatus: selected });

    const table = useNewTable({
        data,
        columns,
        totalItems,
        enableRowSelection: false,
        loading
    });

    const queryFilters = useQueryFilters(table);

    useEffect(() => {
        const controller = new AbortController();
        get({
            page: queryFilters?.pageIndex + 1,
            perPage: queryFilters?.pageSize,
            status: selected
        }, controller);
        return () => controller.abort();
    }, [get, queryFilters, selected]);

    return (
        <Card className="h-100 w-100">
            <CardHeader>
                <h4 className="mb-0">{t("retro-adjustment")}</h4>
            </CardHeader>

            <div className="d-flex gap-1 flex-row py-3 justify-content-end px-3">
                {status.map((item) => (
                    <span
                        key={item}
                        className={classNames(
                            "border rounded px-3 py-1 cursor-pointer text-primary border-primary",
                            selected === item && "bg-primary text-white font-weight-bold"
                        )}
                        onClick={() => setSelected(item)}
                    >
                        {t(item)}
                    </span>
                ))}
            </div>

            <NTable table={table} />

            {detailsModal}
            {approveDenyModal}
        </Card>
    );
}

export default RetroAdjustment;
